import { Link } from "@StarberryUtils";
import React from "react";
import {Col, Row, Container } from 'react-bootstrap';
import  "./Information.scss";
import { useStaticQuery, graphql } from "gatsby";
import ReactMarkdown from "react-markdown"
import cardImg01 from "../../../images/card-img01.jpg"
import cardImg02 from "../../../images/card-img02.jpg"
import cardImg03 from "../../../images/card-img03.jpg"
import cardImg04 from "../../../images/card-img04.jpg"
import cardImg05 from "../../../images/card-img05.jpg"
import cardImg06 from "../../../images/card-img06.jpg"
import { GetURL } from "../../common/site/functions";
import { GetMenuTileImageURL } from "../../common/site/menu-tile-image-path";

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}
const titleVariants = {
  hidden: {
    opacity: 0,
    y: 40 
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}
const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    }
  }
}
const contentItem = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 }
}

const MotionRow = motion(Row)

  const Information=(props)=>{


  const data = useStaticQuery(graphql`
    query{
      strapiGlobalModules {
        Property_Details_Useful_Information_Links {
          Add_Links {
            Select_Link {
              id
            }
            Label
          }
          Title
        }
      }
    }
  `);


    const options = [
        { label: "Vuze", cardImg: cardImg01 },
        { label: "How to Videos", cardImg: cardImg02 },
        { label: "Property Valuation", cardImg: cardImg03 },
        { label: "Guide for Buyers", cardImg: cardImg04 },
        { label: "Guide for Sellers", cardImg: cardImg05 },
        { label: "Contact Us", cardImg: cardImg06 },
    ];

    const RowItem = (props) => {
      const {
        item,
        index
      } = props

      let url = GetURL(item.Select_Link.id)
      let tile_image_url = GetMenuTileImageURL(item.Select_Link.id)
      return(
        <motion.div
          className="list-wrap"
          key={index}
          variants={contentItem}
        >
          <Link to={`/${url}`} className="list-item d-flex align-items-center">
              <figure><img loading="lazy" src={tile_image_url} alt={`${item.Label} - Martyn Gerrard`} title="" /></figure>
              <div className="d-flex justify-content-between align-items-center w-100"><strong>{item.Label}</strong> <span><i className="icon-longarrow-rgt"></i></span></div>
          </Link>
        </motion.div>
      )
    }

  return(
    <InView {...inViewOptions}>
      {({ ref, inView }) => (
        <motion.section
          className="information-sec"
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}
        >
          <Container>
            <motion.div
              variants={titleVariants}
            >
              <ReactMarkdown source={data.strapiGlobalModules.Property_Details_Useful_Information_Links.Title ? data.strapiGlobalModules.Property_Details_Useful_Information_Links.Title : ''} allowDangerousHtml />
            </motion.div>

            <Row>
              <Col lg={12}>
                <motion.div className="service-list" variants={container}>
                  {data.strapiGlobalModules.Property_Details_Useful_Information_Links.Add_Links.map((item, index) => (
                    <RowItem item={item} index={index} />
                  ))}        
                </motion.div>
              </Col>
            </Row>
          </Container>
        </motion.section>
      )}
    </InView>
  )
}

export default Information
